/** The decision templates and the delegation register as Workflow Studio edits them (condition 2.15): each change is a new version the Department approves. */
export default {
  tabTemplates: "Decision templates",
  tabSignatories: "Signatories",
  templatesHint: "The wording of every decision the platform signs. Saving makes a new version; it produces a signable decision only once a legal expert or the Director other than you approves it in the back office (Legal knowledge › Decision templates). Cite every article by its reference in the legal rules register (listed under “Rules of the register”): an article written out is refused.",
  version: "Version {{version}}",
  status: { Approved: "Approved", AwaitingApproval: "Awaiting approval", EditedSinceApproval: "Edited since approval" },
  pending: "Version {{version}} awaits approval",
  editing: "Editing from version {{version}}",
  arabic: "Arabic",
  english: "English",
  note: "What this version changes",
  save: "Save as a new version",
  saved: "New version saved – it awaits the Department's approval",
  placeholders: "Placeholders",
  rules: "Rules of the register",
  choose: "Choose a template to edit its wording.",
  signatoriesHint: "Who signs each decision, in what capacity and under which delegation, with the dates each is in force. An acting appointment names the officer acting (their user ID). Saving makes a new version of the register; decisions are signed under it only once a legal expert or the Director other than you approves it.",
  key: "Key",
  capacity: "Capacity",
  capacityAr: "Capacity (Arabic)",
  authority: "Authority",
  authorityAr: "Authority (Arabic)",
  role: "Signatory role",
  instrument: "Instrument",
  instruments: { Ministerial: "Ministerial decision", Administrative: "Administrative decision" },
  name: "Name",
  nameAr: "Name (Arabic)",
  userId: "Officer's user ID (acting appointments)",
  acting: "Acting",
  from: "In force from",
  to: "In force until",
  outcomes: "Decision outcomes (comma-separated)",
  caseTypes: "Procedures (comma-separated; empty for concentrations)",
  verification: "Verification",
  add: "Add a delegation",
  remove: "Remove",
  savedRegister: "New version of the register saved – it awaits the Department's approval",
} as const;
